import { render, staticRenderFns } from "./whatsappIncomingMessage.vue?vue&type=template&id=54a5aaec&scoped=true&lang=pug&"
import script from "./whatsappIncomingMessage.vue?vue&type=script&lang=ts&"
export * from "./whatsappIncomingMessage.vue?vue&type=script&lang=ts&"
import style0 from "./whatsappIncomingMessage.vue?vue&type=style&index=0&id=54a5aaec&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a5aaec",
  null
  
)

export default component.exports